import { call, put, select } from 'redux-saga/effects'
import { callApi } from '@/shared/tools/apiSagaHelper'

import {
  setCommunicationBoardError,
  updateCommunicationBoardData,
} from '@/containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionFormSlice'
import { selectAuthData, selectExtraRoutesAuthData } from '@/containers/Login/AuthSelectors'

export const communicationBoardModuleActions = {
  COMMUNICATION_BOARD_MODULE_LOAD_DATA: 'COMMUNICATION_BOARD_MODULE_LOAD_DATA',
}

export function* loadCommunicationBoardData() {
  const { country } = yield select(selectAuthData)
  const { communicationBoardUrl } = yield select(selectExtraRoutesAuthData)
  if (!country || !communicationBoardUrl) return
  try {
    const data = yield call(callApi, {
      endpoint: `${communicationBoardUrl}?country=${country}&section=all&lang=${country}`,
      method: 'GET',
      showErrorSnackbar: true,
    })

    yield put(
      updateCommunicationBoardData({
        sections: data.sections || [],
        error: null,
      }),
    )
  } catch (error) {
    yield put(setCommunicationBoardError('Error fetching communication board'))
  }
}
